// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"93c8c42b","255":"ea613a4f","484":"e059cf2f","573":"d63c217b","858":"b5a14a80","948":"97277420"}[chunkId] + ".chunk.css";
};